import { FRONTEND_PROPERTY_NAME, VALID_INTENTS, } from '../../common/constants.js';
export function validateIntent(node, nodeFields, accept) {
    const { idField, intentField } = nodeFields;
    // We want to ensure that if the intent if provided, is
    // from the list of valid intents
    const validIntents = Object.values(VALID_INTENTS);
    if (intentField && intentField?.intent?.$type !== 'EmptyField') {
        if (validIntents.indexOf(intentField?.intent?.value) === -1) {
            accept('error', `Invalid intent value '${intentField.intent.value}' found.`, {
                node: intentField,
                data: {
                    id: idField?.id?.value,
                    nodeNumber: node?.name,
                    propertyName: FRONTEND_PROPERTY_NAME.INTENT,
                },
            });
        }
    }
}
//# sourceMappingURL=validate-intent.js.map